
import BusinessLogo from "@/components/business/BusinessLogo"
import Card from "@/components/base/card/Card"
import Button from "@/components/base/Button"
import { routeToBusiness } from "@/helpers/routing"

export default {
    components: { Card, BusinessLogo, Button },
    props: {
        companies: {
            type: Array,
            required: true,
        },
        from: {
            type: String,
            default: "",
        },
        until: {
            type: String,
            default: "",
        },
        date: {
            type: String,
            default: "",
        },
        live: {
            type: Boolean,
            default: false,
        },
        link: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        companyList() {
            return this.companies.map((c) => c.name).join(" ● ")
        },
        singleBusiness() {
            return this.companies.length === 1
        },
    },
    methods: {
        onCardClick() {
            if (!this.link || !this.singleBusiness) return

            const company = this.companies[0]

            if (company) {
                // Do not mount Floating Window on any iOS device (done via native iOS floating video)
                if (!this.$ua.isFromIos()) {
                    this.$store.dispatch("livestream/closeWindow", true)
                }
                this.$router.push(routeToBusiness(company))
            }
        },
        onShowJobs() {
            if (!this.singleBusiness) return
            this.$store.dispatch("ui/setGlobalComponent", {
                component: import(
                    "@/components/livestream/LivestreamJobOverview"
                ),
                options: {
                    noPadding: true,
                    transparent: true,
                },
                props: { business: this.companies[0] },
            })
        },
    },
}
